import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IGenerateBpaMatchPayload {
    company: string
    businessPotential: string
    sagaCB?: {
        onSuccess?: any
        onError?: any
    }
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const generateBpaMatch = createSlice({
    name: 'hub/matchLists/generate-bpa-match',
    initialState,
    reducers: {
        onRequest(state, actions: PayloadAction<IGenerateBpaMatchPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.data = { count: 0, data: [] }
            state.errors = action.payload
        }
    }
})

export const generateBpaMatchActions = generateBpaMatch.actions
export default generateBpaMatch.reducer
